<template>
  <section class="lms-container">
    <confirmation-modal
      :text="'Deseja realmente remover o tópico selecionado?'"
      v-if="confirmDelete"
      @confirm="confirmRemove()"
      @cancel="confirmDelete=false"
    />
    <new-topic v-if="showNewTopic" @close="showNewTopic=false;getAll();" :newtopic="selectedTopic" />
    <div class="content">
      <div class="title-section-content">
        <h3>Fórum</h3>
      </div>

      <div class="text-center">
        <lms-button
          :disabled="false"
          :loading="false"
          @click="selectedTopic={};showNewTopic=true"
          v-show="user.type==0 || user.type == 2"
        >Novo tópico</lms-button>
      </div>

      <div class="topics-list">
        <div class="topic" v-for="topic in topics" :key="topic.id">
          <div class="topic-description-bar">
            <span class="topic-owner">Publicado por: {{topic.userName}}</span>
            <span class="topic-published-date">em {{topic.publishedOn | formatDate}}</span>
          </div>

          <div class="topic-title-bar">
            <div class="text-content">
              <h5
                v-if="topic.length<262"
                class="cropped-text"
                style="font-size: 14px;"
              >{{topic.text}}</h5>
              <h5
                v-else
                class="cropped-text"
                style="font-size: 14px;"
              >{{ topic.text.substring(0,262)+"..." }}</h5>

              <div class="topic-info-bar">
                <!-- <span
                  class="topic-published-date"
                >Disponível de: 29/10/2019 08:30 à 12/11/2019 00:00</span>-->
                <span>{{topic.commentCount}} comentário(s)</span>
              </div>
            </div>
            <a
              v-show="  user.type==0 || ( user.type == 2 ? topic.userId == user.id:false )"
              @click="remove(topic.id)"
              href="#"
              class="go-to-topic"
              style="font-size: 14px;"
            >Remover</a>
            <a
               v-show="  user.type==0 || ( user.type == 2 ? topic.userId == user.id:false )"
              @click="selectedTopic=topic;showNewTopic=true"
              href="#"
              class="go-to-topic"
              style="font-size: 14px;"
            >Editar</a>
            <a
              @click="viewTopic(topic)"
              href
              class="go-to-topic"
              style="font-size: 14px;"
            >Visualizar</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import axios from "axios";
import NewTopic from "./NewTopic";

export default {
  data() {
    return {
      confirmDelete: false,
      user: this.$store.getters.user,
      loading: false,
      showNewTopic: false,
      topics: [],
      courses: [],
      removeItem: 0
    };
  },
  components: {
    NewTopic
  },
  methods: {
    remove(topicId) {
      this.removeItem = topicId;
      this.confirmDelete = true;
    },
    confirmRemove() {
      this.confirmDelete = false;
      const path = this.$global.endpoint + "/forum/topic/remove";
      axios
        .post(path, {
          topicId: this.removeItem
        })
        .then(res => {
          this.removeItem = 0;
          this.getAll();
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Tópico removido com sucesso"
          });
        })
        .catch(error => {
          this.loading = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    getAll() {
      this.loading = true;
      const path = this.$global.endpoint + "/forum/topic/getall";
      axios
        .get(path)
        .then(res => {
          this.topics = res.data;
        })
        .catch(error => {
          this.loading = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    viewTopic(topic) {
      this.$store.commit("change_topic", topic);
      this.$router.push("/home/viewtopic");
    }
  },
  created() {
    this.getAll();
  }
};
</script>
